import React from "react";
import "./App.css"; // Import style cho file App.tsx nếu có
import StudentPage from "./page/StudentPage/StudentPage";

const App: React.FC = () => {
  return (
    <div>
      <div>
        <StudentPage />
      </div>
    </div>
  );
};

export default App;
